import { AlignmentType, BorderStyle, HeightRule, Paragraph, ShadingType, Table, TableCell, TableLayoutType, TableRow, TextDirection, TextRun, VerticalAlign, WidthType } from "docx";


export function summaryText(certInCustomerName, certInApplicationName) {
    return new Paragraph({
        alignment: AlignmentType.LEFT,
        spacing: { before: 200, after: 300 },
        children: [
            new TextRun({
                text: certInCustomerName + " " + "engaged ISECURION for performing Web Application Security Audit of their" + " " + certInApplicationName + " " + "Web Application.",
                size: 24,
                color: "000000",
                font: "Arial",
                bold: false,
                italics: false
            })
        ],
    })
}

export const summaryText1 = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 700, after: 300 },
    children: [
        new TextRun({
            text: "NOTE:",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export function sumaryText2(certInAppEnvironment, certInTestingype) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 250, after: 500 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: "Testing was performed on the" + ' ' + certInAppEnvironment + ' ' + "Environment." + ' ' + certInTestingype + ' ' + (certInTestingype === "Black box testing methodology (Unauthenticated Testing)" ? "was performed." : "was performed with below-mentioned user role:"),
                size: 24,
                font: "Arial",
                color: '000000',
                italics: false,
                bold: false
            }),
        ],
    })
}

export function summaryUserRoles(certInRoles) {
    const names = Array.isArray(certInRoles) ? certInRoles : [];

    const rows = [
        new TableRow({
            children: [
                new TableCell({
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                    children: [new Paragraph({
                        spacing: { before: 1, after: 1 },
                        alignment: AlignmentType.CENTER,
                        children: [new TextRun({
                            text: "",
                            font: "Arial",
                            size: 26,
                            color: '0f0f3f',
                            italics: false
                        })]
                    })],
                }),
                new TableCell({
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                    children: [new Paragraph({
                        spacing: { before: 10, after: 10 },
                        alignment: AlignmentType.LEFT,
                        children: [new TextRun({
                            text: "",
                            font: "Arial",
                            size: 24,
                            color: '0f0f3f',
                            italics: false
                        })]
                    })],
                }),
            ]
        })
    ];

    names.forEach((name) => {
        rows.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        children: [new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.CENTER,
                            children: [new TextRun({
                                text: "\u2022",
                                font: "Arial",
                                size: 26,
                                color: '0f0f3f',
                                italics: false
                            })]
                        })],
                    }),
                    new TableCell({
                        width: { size: 30, type: WidthType.PERCENTAGE },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        },
                        children: [new Paragraph({
                            spacing: { before: 60, after: 60 },
                            alignment: AlignmentType.LEFT,
                            children: [new TextRun({
                                text: name,
                                font: "Arial",
                                size: 24,
                                color: '000000',
                                italics: false,
                                bold: false
                            })]
                        })],
                    }),
                ]
            })
        );
    });


    return new Table({
        width: { size: 35, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.LEFT,
        indent: { size: 600, type: WidthType.DXA },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        },
        rows: rows
    });
}

export const SummaryRecommendation = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 850, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "It is recommended to:",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: false,
            bold: true
        }),
    ],
})

export const recommendationBulletOne = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 350, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "Ensure that all vulnerabilities are fixed.",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false
        })
    ]
})

export const recommendationBulletTwo = new Paragraph({
    indent: { left: 600 },
    bullet: { level: 0 },
    spacing: { line: 350, after: 10 * 72 * 0.05 },
    children: [
        new TextRun({
            text: "As part of an effective organizational risk management strategy, vulnerability assessments & penetration test should be conducted on regular basis.",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})


export const determination = new Paragraph({
    spacing: { before: 250, after: 350 },
    children: [
        new TextRun({
            text: "Severity Determination",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})


export const determination1 = new Paragraph({
    spacing: { line: 276 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: `This section provides the indication of the severity of vulnerabilities identified, and the priority with which the same needs to be addressed by business units. The vulnerabilities are categorized as per industry framework "Common Vulnerability Scoring System v3.1" i.e. CVSS3.1 scoring. The severity rating represented below is Base Score which represents only the intrinsic characteristics of a vulnerability that are constant over time and across user environments.`,
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false
        })
    ]
})

export const determination2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 350, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Note:",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: true,
            bold: true
        }),
        new TextRun({
            text: " Business units should supplement the base CVSS score with the contextual analysis of the environment, and with attributes that may change over time by leveraging CVSS Temporal and Environmental Metrics. More appropriately, a comprehensive risk assessment system should be employed that considers more factors than simply the CVSS Base Score and represent actual risk.",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: true,
            bold: false
        }),
    ],
})

export const cvssMapping = new Paragraph({
    spacing: { before: 500, after: 350 },
    children: [
        new TextRun({
            text: "CVSS 3.1 MAPPING",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export const cvssMappingTable = new Table({
    width: { size: 45, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { before: 450 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    width: { size: 50, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity Category",
                                    font: "Arial",
                                    size: 24,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "002060" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    width: { size: 50, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "CVSS Score Range",
                                    font: "Arial",
                                    size: 24,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "002060" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Critical",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "9.0 - 10",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),

                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "High",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "7.0 - 8.9",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),

                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Medium",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "4.0 -6.9",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Low",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "0.1 - 3.9",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),

                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Informational",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 50, after: 50 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "0.0",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: true,
                                }),
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
    ]
})


export const riskRating = new Paragraph({
    spacing: { before: 200, after: 250 },
    children: [
        new TextRun({
            text: "Risk Rating based on Severity:",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})


export const riskRatingTable = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 135,
                                after: 135
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Rating",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "D9E2F3",
                    },

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    width: { size: 80, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 135,
                                after: 135
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "D9E2F3",
                    },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },

                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "C (Critical)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            indent: {
                                left: 100,
                                right: 100
                            },
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            spacing: { line: 270 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Critical vulnerability has a high potential of impacting business operations leading to downtime or disruption and provides an attacker with privileged access, customer service or SLA breach resulting in significant outage. If exploited, it has a direct impact on confidentiality, integrity or availability of organizational information.",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    color: "000000",
                                    bold: false
                                }),
                            ]
                        }),
                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                })
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "H (High)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })]
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "High vulnerability has a high potential of impacting business operations leading to downtime or disruption. This type of vulnerability can be exploited publicly, workaround or fix/patch available by vendor.",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    bold: false
                                }),

                            ]
                        }),

                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "M (Medium)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Medium vulnerability has a potential of indirectly giving access to an intruder and/or doesn't have the features enabled for collecting evidence or notifying the attacker of unauthorized use for taking the legal action in case the vulnerability gets exploited. This type of vulnerability upon exploitation might result in elevation of privileges or slowing down the operations.",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    bold: false
                                }),
                            ]
                        }),

                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "L (Low)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Low vulnerability has the potential of revealing the information about the device and may lead to unauthorized access to system leading to compromise. Higher work factor would be involved for exploiting this type of vulnerability.",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    bold: false
                                }),
                            ]
                        }),
                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "I (Informational)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "These vulnerabilities are relatively very low risk or no risk but must be addressed in subsequent development cycle to avoid any future exposure.",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    bold: false
                                }),
                            ]
                        }),
                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),
            ]
        }),
    ]
})


export const exploitation = new Paragraph({
    spacing: { before: 700, after: 250 },
    children: [
        new TextRun({
            text: "Ease of Exploitation",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export const exploitationTable = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,

    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    width: { size: 20, type: WidthType.PERCENTAGE },

                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Easy",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    width: { size: 80, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.CENTER,

                    children: [
                        new Paragraph({
                            indent: { left: 80, right: 80 },
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Requires little-to-no technical/application knowledge on behalf of an attacker and can be exploited using standard operating system tools.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Moderate",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            indent: { left: 80, right: 80 },
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Requires some technical/application knowledge for an attacker to exploit, which could be performed using standard operating system tools or tools downloaded from the Internet.",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Difficult",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            indent: { left: 80, right: 80 },
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Requires specific technical/application knowledge on behalf of an attacker. The issue could be exploited using a combination of operating system tools or publicly available tools downloaded from the Internet.",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                }),

                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        })
    ]
})

export const graphText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 600 },
    alignment: AlignmentType.CENTER,
    children: [
        new TextRun({
            text: "Graphical representation of Identified Vulnerabilities to Severity Risk rating",
            size: 24,
            font: "Arial",
            color: '000000',
            bold: true,
            italics: false
        }),
    ],
})

export const tableText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.CENTER,
    children: [
        new TextRun({
            text: "Table: Representing Severity Level",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: true,
            bold: false
        }),
    ],
})


export function severityLevelTable(certInCritical, certInHigh, certInMedium, certInLow, certInInfo) {
    return new Table({
        width: { size: 55, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { before: 1200 },
        borders: {
            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
        },

        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 13, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 110, after: 110 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Sl. No",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        indent: { left: 800 },
                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                        textDirection: TextDirection.VERTICAL,
                    }),

                    new TableCell({
                        width: { size: 59, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 110, after: 110 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Severity Level",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: {
                            type: ShadingType.SOLID,
                            color: "003366",
                        },
                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                        textDirection: TextDirection.VERTICAL,
                    }),

                    new TableCell({
                        width: { size: 28, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 110, after: 110 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Frequency",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: {
                            type: ShadingType.SOLID,
                            color: "003366",
                        },
                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                        textDirection: TextDirection.VERTICAL,
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "1",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                indent: { left: 80 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Critical",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: certInCritical,
                                        font: "AriaCalibri (Body)l",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.THICK, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "2",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                indent: { left: 80 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "High",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: certInHigh,
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "3",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                indent: { left: 80 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Medium",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: certInMedium,
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "4",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                indent: { left: 80 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Low",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: certInLow,
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "5",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                indent: { left: 80 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Informational",
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 50, after: 50 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: certInInfo,
                                        font: "Calibri (Body)",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            bottom: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            left: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                            right: { style: BorderStyle.SINGLE, size: 3 * 8, color: "f8f8f8" },
                        },
                    }),
                ]
            }),
        ]
    })
}

export const graphText1 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { before: 650, after: 200 },
    alignment: AlignmentType.CENTER,
    children: [
        new TextRun({
            text: "Graphical Representation of Identified Gaps",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: true,
            bold: false
        }),
    ],
})

export const vulnerabilityTables = new Table({
    width: { size: 10335, type: WidthType.DXA },
    alignment: AlignmentType.CENTER,
    layout: TableLayoutType.FIXED,
    spacing: { before: 600 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
    },

    rows: [
        new TableRow({
            height: { value: 3000, rule: HeightRule.EXACT },
            children: [
                new TableCell({
                    width: { size: 600, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Sl No.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Affected Asset i.e. IP/URL/Application etc.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Observation/Vulnerability title",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 800, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "CVE/CWE",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 2500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Recommendation",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1200, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Reference",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1000, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "New or Repeat observation",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    textDirection: TextDirection.BOTTOM_TO_TOP_LEFT_TO_RIGHT, // Text rotation property
                    shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ],
        }),

        new TableRow({
            height: { value: 3000, rule: HeightRule.EXACT },
            children: [
                new TableCell({
                    width: { size: 600, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "1",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "http://localhost/isecurion/generatereport",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],


                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Remote Code Execution through Web Shell file upload",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 800, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "CVE:123",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],


                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "Critical",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],


                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 2500, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "An attacker can upload a malicious file and gain the root access of the server, after gaining access to the web server attacker can perform any malicious operations.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],


                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1200, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "https://cheatsheetseries.owasp.org/cheatsheets/File_Upload_Cheat_Sheet.html",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],



                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
                new TableCell({
                    width: { size: 1000, type: WidthType.DXA },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.RIGHT,
                            indent: { left: 50, right: 50, top: 50, bottom: 50 },
                            children: [
                                new TextRun({
                                    text: "New ",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: false,
                                }),
                            ],
                        }),
                    ],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ],
        }),
    ],
});


